
import React, { useEffect, useRef, useState } from "react";
import Commonmodal from "../../crm/commonModal";
import { useDispatch, useSelector } from "react-redux";
import { selectUser } from "../../ReduxStore/userReducer";
import { useNavigate } from "react-router-dom";
import { fetchGetCRMData } from "../../ReduxStore/reduxThunk";
import {CRMPostData } from "../../ReduxStore/actions";
import "./sharedCrm.css";
import { GetGuestCode, GetSalesPerson } from "../../API/Greeter/GreeterThunk";
import DynamicForm from "./DynamicInputfield";
import { useSharedCrm } from "../../itemPage/sharedCrmContext";

const SharedCrm = ({customer}) => {
  const { formData, setFormData, handleFieldchange, setDropdownOpen,setFormDataError } = useSharedCrm();
  const [open, setOpen] = React.useState(false);
  const handleClose = () => setOpen(false);
  const userdata = useSelector(selectUser);
  const databaseName = userdata?.DatabaseName;
  const jwtToken = userdata?.JwtToken;
  const slpCode = userdata?.SlpCode;
  const { fetchGuestCode } = useSelector((state) => state.greeterData);
  const errors = useSelector((state) => state.greeterData);
  const [CrmFullData, setCrmFullData] = useState([]);
  const [modalValue, setModalValue] = useState();
  const [modalName, setModalName] = useState();
  const [DueDate, setDueDate] = React.useState();
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const { CustomerMaster } = useSelector((state) => state.CustomerMaster);
  const [guestCodes, setGuestCodes] = useState([]);
  const { GetSalesPersonData } = useSelector(state => state.greeterData);
 
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    fetchCrmData();
  }, [dispatch]);

  useEffect(() => {
    if (fetchGuestCode?.length > 0) {
      setGuestCodes(fetchGuestCode);
    }
    else if (!fetchGuestCode && userdata?.slpCode) {
      dispatch(GetGuestCode({ slpCode: userdata.slpCode }));
    }
  }, [fetchGuestCode, userdata?.slpCode]);

  const fieldOrder = [
    // "GreeterCode",
    "customerCategory",
    "WalkInType",
    "Reference",
    "LeadLevel",
    // "AssignExecutive",
    "CustomerProfile",
    "Segment",
    "SiteType",
    "CurrentWorkStatus",
    "ExpectedComplationOfWork",
    "ItemsChecked",
    "EstimatedValue",
    "ReqType",
    "SiteVist",
    "Address",
  ];
  const modalFields = [
    "customerCategory",
    "WalkInType",
    "Reference",
    "LeadLevel",
    // "AssignExecutive",
    "CustomerProfile",
    "Segment",
    "SiteType",
    "CurrentWorkStatus",
    "ExpectedComplationOfWork",
    "ItemsChecked",
    "EstimatedValue",
    "ReqType",
  ];

  const {
    item1: customerCate,
    item2: u_Segment,
    item3: u_CustomPro,
    item4: u_SiteType,
    item5: u_WalkType,
    item6: u_ReqType,
    item7: u_CurrentWS,
  } = CrmFullData;
 

  const openModalForField = (fieldName) => {
   
    switch (fieldName) {
      case "AssignExecutive":
        setModalValue(GetSalesPersonData);
        break;
      case "customerCategory":
        setModalValue(customerCate);
        // setCustcatError("");
        break;
      case "Segment":
        setModalValue(u_Segment);
        break;
      case "CustomerProfile":
        setModalValue(u_CustomPro);
        break;
      case "SiteType":
        setModalValue(u_SiteType);
        break;
      case "WalkInType":
        setModalValue(u_WalkType);
        break;
      case "ReqType":
        setModalValue(u_ReqType);
        break;
      case "CurrentWorkStatus":
        setModalValue(u_CurrentWS);
        break;
      default:
        setModalValue(null);
    }
    setModalName(fieldName);
    setOpen(true);
  };
  const fetchCrmData = async () => {
    if (userdata || userdata?.databaseName) {
      try {
        // Fetch CRM data
        const crmResponse = await fetchGetCRMData(
          databaseName,
          jwtToken,
          dispatch,
          navigate
        );
        setCrmFullData(crmResponse);
      } catch (crmError) {
        // console.log("CRM Data Fetch Error:", crmError);
      }
      dispatch(GetSalesPerson({ databaseName }))
    }
  };

  const handleFieldSelect = (fieldName, value) => {
    setFormDataError((prevErrors) => ({
      ...prevErrors,
      [fieldName]: "", // Clear error for this field
    }));
    const updatedFormData = {
      ...formData,
      [fieldName]: value,
    };
    if (fieldName === "AssignExecutive") {
      const slpname = value.SlpName;
      const code = value.code;
      updatedFormData.ExecutiveId = code;
      updatedFormData.AssignExecutive = slpname || "";
      
    }
  
    setFormData(updatedFormData);
    dispatch(CRMPostData(updatedFormData));
    if (fieldName === "LeadLevel") {
      openNextModal(fieldName);  // Open the next modal for LeadLevel
      setIsDropdownVisible(false);  // Optionally hide dropdown
    }
  };


  const handleLeadLevelClick = (event) => {
    setIsDropdownVisible(true);
  };
  const handleForward = (modalName) => {
    openNextModal(modalName); // This ensures openNextModal gets triggered with the correct modalName
  };
const handleCloseModel=()=>{
  setOpen(false);
}
  // const openNextModal = (currentName) => {


  //   const currentIndex = fieldOrder.indexOf(currentName);
  //   const nextField = fieldOrder[currentIndex + 1];
   
  //   if (nextField) {
  //     if (modalFields.includes(nextField)) {
  //       openModalForField(nextField);
  //     } else if (nextField === "Segment" || nextField === "ItemsChecked") {
  //       const inputField = document.querySelector(`input[name="${nextField}"]`);
  //       if (inputField) {
  //         inputField.focus();
  //       }
  //     } else {
  //       const inputField = document.querySelector(`input[name="${nextField}"]`);
  //       if (inputField) {
  //         inputField.focus();  // Focus on the input field
  //       }
  //     }
  //   }
  // };

  const openNextModal = (currentName,selectedValue=null) => {
    const currentIndex = fieldOrder.indexOf(currentName);
    let nextIndex=currentIndex + 1
    let nextField = fieldOrder[nextIndex];
    const WalkInType=selectedValue || formData.WalkInType;
    if(nextField==="Reference"&& WalkInType==="Direct"){
      setFormData((prev)=>({...prev,Reference:"Direct"}))
      dispatch(CRMPostData({...formData,Reference:"Direct",WalkInType:WalkInType}))
      nextIndex=nextIndex+1
      nextField=fieldOrder[nextIndex]
    }
   
    if (nextField) {
      if (modalFields.includes(nextField)) {
        openModalForField(nextField);
      } else if (nextField === "Segment" || nextField === "ItemsChecked") {
        const inputField = document.querySelector(`input[name="${nextField}"]`);
        if (inputField) {
          inputField.focus();
        }
      } else {
        const inputField = document.querySelector(`input[name="${nextField}"]`);
        if (inputField) {
          inputField.focus();  // Focus on the input field
        }
      }
    }
  };
  const openPreviousModal = (currentName) => {
    const currentIndex = fieldOrder.indexOf(currentName);
    const previousField = fieldOrder[currentIndex - 1];

    if (previousField) {
      if (modalFields.includes(previousField)) {
        openModalForField(previousField);
      } else {
        const inputField = document.querySelector(
          `input[name="${previousField}"]`
        );
        if (inputField) {
          inputField.focus();
          setOpen(false);
        }
      }
    }
  };
  const formLabels = [
    {
      label: "GreeterCode",
      field: "GreeterCode",
      type: "customDropdown",
      required: true,
      searchValue: "GuestCode",
      message: "GuestCode not available",
      options: guestCodes || [],
      allowCustomInput: false,
      getDisplayValue: (item) => `${item.GuestCode} - ${item.customerName}`,
      selectedValues: {
        GreeterCode: "GuestCode",           // 👈 main value for the dropdown field
        // CustomerCode: "customerCode",       // 👈 mapped from selected item
        // CustomerName: "customerName",
        CustomerName: "customerName",
        CustomerCode:"customerCode",  
        PhoneNo:"phoneNum",
        // PhoneNo: "phoneNum",
        // existingcust: "existingcust"
      }
    },
    {
      label: "Phone Number",
      field: "PhoneNo",
      type: "customDropdown",
      required: true,
      // searchValue: "PhoneNumber",
      searchValue: "phoneNum",
      message: "No customerName found",
      options: CustomerMaster || customer||[],
      allowCustomInput: true,
      // getDisplayValue: (item) => `${item.customerCode} - ${item.customerName}-${item.phoneNumber}`,
      getDisplayValue: (item) => `${item.phoneNum} - ${item.customerName}-${item.customerCode}`,
      selectedValues: {
        CustomerCode: "customerCode",       // 👈 mapped from selected item
        CustomerName: "customerName",
        PhoneNo: "phoneNum",
        GreeterCode: "GuestCode",
      }
      

    },
    {
      label: "Customer Name",
      field: "CustomerName",
      type: "customDropdown",
      required: true,
      searchValue: "CustomerName",
      message: "No customerName found",
      options: CustomerMaster || customer||[],
      allowCustomInput: true,
      getDisplayValue: (item) => `${item.customerCode} - ${item.customerName}`,
      selectedValues: {
        CustomerCode: "customerCode",
        CustomerName: "customerName",
        PhoneNo: "phoneNum",
        GreeterCode: "GuestCode",
      }
    },
    {
      label: "Customer Category",
      field: "customerCategory",
      required: true,
      type: "RadioButton",
      message: "Customer Category is required",
    },
    {
      label: "Walk In Type",
      field: "WalkInType",
      required: true,
      type: "RadioButton",
      message: "Walk In Type is required",
    },
    {
      label: "Reference",
      field: "Reference",
      type: "text",
      required: true,
      message: "Reference is required",
    },
    {
      label: "Lead Level",
      field: "LeadLevel",
      type: "RadioButton",
      required: true,
      message: "Lead Level is required",
    },
    {
      label: "Assign Executive",
      field: "AssignExecutive",
      type: "RadioButton",
      required: true,
      message: "Assign Executive is required",
    },
    {
      label: "Customer Profile",
      field: "CustomerProfile",
      type: "RadioButton",
      required: true,
      message: "Customer Profile is required",
    },
    {
      label: "Segment",
      field: "Segment",
      type: "RadioButton",
      required: true,
      message: "Segment is required",
    },
    {
      label: "Site Type",
      field: "SiteType",
      type: "RadioButton",
      required: true,
      message: "Site Type is required",
    },
    {
      label: "Current Work Status",
      field: "CurrentWorkStatus",
      type: "RadioButton",
      required: true,
      message: "Current Work Status is required",
    },
    {
      label: "Completion of Work",
      field: "ExpectedComplationOfWork",
      type: "dateField",
      required: true,
      message: "Completion of Work is required",
    },
    {
      label: "Items Checked",
      field: "ItemsChecked",
      type: "RadioButton",
      required: false,
      message: "Items Checked is required",
    },
    {
      label: "Esitmated Value",
      field: "EstimatedValue",
      type: "text",
      required: true,
      message: "Esitmated Value is required",
    },
    {
      label: "Requirement",
      field: "ReqType",
      type: "RadioButton",
      required: true,
      message: "Requirement is required",
    },
    {
      label: "Site Visit",
      field: "SiteVist",
      type: "Checkbox",
      required: true,
      message: "Site Visit is required",
    },
    {
      label: "Address",
      field: "Address",
      type: "textarea",
      required: true,
      message: "Site Visit is required",
    },
  ];
 
  
  // const handleChange = (e) => {
  //   const { name, value, type, checked, } = e.target;
  //   console.log("value",value);
    
    
  //   handleFieldchange({name,value,type,checked})
  //   if(name!=="ItemsChecked" &&type!=="checkbox"){
  //   if (name === "Reference" || name === "EstimatedValue") {
  //     return;
  //   } else {
  //     setOpen(false);
  //   }
  //   if (!(name === "PhoneNo" || name === "Reference" || name === "EstimatedValue")
  //   ) {
  //     openNextModal(name,value);
  //   }
  // }



  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
  
    handleFieldchange({ name, value, type, checked });
  
    // If WalkInType is changed, reset Reference
    if (name === "WalkInType") {
      setFormData((prev) => ({
        ...prev,
        WalkInType: value,
        Reference: value === "Direct" ? "Direct" : "", // reset Reference
      }));
      dispatch(
        CRMPostData({
          ...formData,
          WalkInType: value,
          Reference: value === "Direct" ? "Direct" : "",
        })
      );
  
      // Then move to next field automatically
      openNextModal(name, value);
      return; // exit early to avoid running rest of code
    }
  
    // If it's a normal field, handle modal/next field
    if (name !== "ItemsChecked" && type !== "checkbox") {
      if (name === "Reference" || name === "EstimatedValue") {
        return; // don't auto-close modal for these
      } else {
        setOpen(false);
      }
  
      if (!(name === "PhoneNo" || name === "Reference" || name === "EstimatedValue")) {
        openNextModal(name, value);
      }
    }
  
//     if (name === "EstimatedValue") {
//       if (isNaN(value) || value === "") {
//         alert("Please enter a valid number for EstimatedValue.");
//         return;
//       }
//     }
//     if (name === "SiteVist") {
//       setFormData((prevData) => {
//         let updatedFormData = { ...prevData};
//         if (value === "YES") {
//           setShowAddress(true);
//           setScrollAddress(true);
//           updatedFormData = {
//             ...prevData,
//             SiteVist: value ,
//           };
//         } else if (value === "NO") {
//           setShowAddress(false);
//           setScrollAddress(false);
//           updatedFormData = {
//             ...prevData,
//             SiteVist: value ,
//             Address: ""
//           };
//         }
//         dispatch(CRMPostData(updatedFormData));
//         return updatedFormData;
//       });
//       return;
//     }

//     if (type === "checkbox") {
//       setFormDataError((prevErrors) => ({
//         ...prevErrors,
//         [name]: "",
//       }));
//       setFormData((prevData) => {
//         const prevItems = Array.isArray(prevData.ItemsChecked)
//           ? prevData.ItemsChecked
//           : [];

//         const updatedItems = checked
//           ? [...prevItems, { itemCode: name, itemName: value }]
//           : prevItems.filter((item) => item.itemCode !== name);

//         const updatedFormData = {
//           ...prevData,
//           ItemsChecked: updatedItems,
//         };
//         dispatch(CRMPostData(updatedFormData));
//         return updatedFormData;
//       });
  
//   } else {
//     let updatedFormData = {
//       ...formData,
//       [name]: value,
//     };
//   if (name === "ReqType") {
//     const currentDate = new Date();
//     let closingDate;
//     if (value === "By One Month") {
//       currentDate.setDate(currentDate.getDate() + 15); // Add 15 days to the current date
//       closingDate = currentDate.toISOString().split('T')[0]; // Format date as YYYY-MM-DD
//     }
//     if (value === "By One Week") {
//       currentDate.setDate(currentDate.getDate() + 3); // Add 15 days to the current date
//       closingDate = currentDate.toISOString().split('T')[0]; // Format date as YYYY-MM-DD
//     }
//     if (value === "Immediate") {
//       currentDate.setDate(currentDate.getDate() + 1); // Add 15 days to the current date
//       closingDate = currentDate.toISOString().split('T')[0]; // Format date as YYYY-MM-DD
//     }
//     if (value === "Today") {
//       currentDate.setDate(currentDate.getDate()); // Add 15 days to the current date
//       closingDate = currentDate.toISOString().split('T')[0]; // Format date as YYYY-MM-DD
//     }
//     updatedFormData.ClosingDate = closingDate; // Set the ClosingDate
//   }
//   setFormData(updatedFormData);
//   dispatch(CRMPostData(updatedFormData)); // Dispatch the updated formData immediately
//   sessionStorage.setItem('CRMPostData', JSON.stringify(updatedFormData));
  // if (name === "Reference" || name === "EstimatedValue") {
  //   return;
  // } else {
  //   setOpen(false);
  // }
  // if (!(name === "PhoneNo" || name === "Reference" || name === "EstimatedValue")
  // ) {
  //   openNextModal(name);
  // }
// }
  };
return (
  <>
    <DynamicForm
      labels={formLabels}
      formData={formData}
      handletextField={handleChange}
      handleFieldSelect={handleFieldSelect}
      handleOpenRadioModal={openModalForField}
      setFormData={setFormData}
      customer={customer}
    />
    <div className="customer-creation">
      <Commonmodal
        open={open}
        handleClose={handleClose}
        handleChange={handleChange}
        formData={formData}
        modalValue={modalValue}
        modalName={modalName}
        handleBack={() => openPreviousModal(modalName)}
        handleForward={handleForward}
        handleCloseModel={handleCloseModel}
        handleLeadLevelClick={handleLeadLevelClick}
        handleFieldSelect={handleFieldSelect}
        isDropdownVisible={isDropdownVisible}
        DueDate={DueDate}
      />
    </div>
  </>
);
};

export default SharedCrm;
